import "./Payments.scss";
import { Tabs } from "antd";
import CustomCard from "../../components/CustomCard/CustomCard";
import { useSelector } from "react-redux";
import PaymentsTable from "./Components/PaymentsTable";
import { capitalizeEntireWord } from "../../helpers/helpers";
import { useMemo, useState, useEffect } from "react";
import { PERM_CODE } from "../../constants/PermissionCodes";
import { isRootOrSuperAdmin } from "../../constants/constants";
import { SHOW_MARK_AS_DUPLICATE } from "../../constants/manualDuplicate";

const Payments = () => {
  const { txnHistoryData /*, rejectedDisputeData, pendingApprovalData, suspenseData */ } =
    useSelector((state) => state?.payments);
  const { user } = useSelector((state) => state.auth);

  // extract privilege codes from user
  const userPrivileges = useMemo(
    () => user?.privilege?.map((p) => p.privilegeCode) || [],
    [user]
  );

  // define all tabs with their privilege requirement and data source
  // Dispute / Rejected / Pending / Suspicious tabs temporarily hidden for Payments;
  // keep definitions commented so they can be restored later.
  const allTabs = useMemo(
    () => [
      {
        key: "1",
        label: "Transaction History",
        privilege: PERM_CODE.PTACC,
        data: txnHistoryData,
      },
      // {
      //   key: "2",
      //   label: "Dispute Transactions",
      //   privilege: PERM_CODE.PDACC,
      //   data: rejectedDisputeData,
      // },
      // {
      //   key: "3",
      //   label: "Rejected Transactions",
      //   privilege: PERM_CODE.PRACC,
      //   data: rejectedDisputeData,
      // },
      // {
      //   key: "4",
      //   label: "Pending Approvals",
      //   privilege: PERM_CODE.PPACC,
      //   data: pendingApprovalData,
      // },
      // {
      //   key: "5",
      //   label: "Suspicious Transactions",
      //   privilege: PERM_CODE.PPACC,
      //   data: suspenseData,
      // },
    ],
    [txnHistoryData /*, rejectedDisputeData, pendingApprovalData, suspenseData */]
  );

  // filter tabs based on privileges
  const visibleTabs = useMemo(
    () => allTabs.filter((tab) => userPrivileges.includes(tab.privilege)),
    [allTabs, userPrivileges]
  );

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (visibleTabs.length) {
      setActiveTab((prev) =>
        visibleTabs.some((t) => t.key === prev)
          ? prev
          : visibleTabs[0].key
      );
    }
  }, [visibleTabs]);

  if (!visibleTabs.length) {
    return <CustomCard>No permission to view Payments.</CustomCard>;
  }

  if (!activeTab) {
    return <CustomCard>Loading payments...</CustomCard>;
  }

  const activeData =
    visibleTabs.find((t) => t.key === activeTab)?.data || [];

  return (
    <CustomCard className="payments-page-card">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className="payments-tabs"
        items={visibleTabs.map((tab) => ({
          key: tab.key,
          label: capitalizeEntireWord(tab.label),
        }))}
      />

      <PaymentsTable
        tabIndex={parseInt(activeTab)}
        data={activeData}
        canMarkDuplicate={SHOW_MARK_AS_DUPLICATE && isRootOrSuperAdmin(user)}
      />
    </CustomCard>
  );
};

export default Payments;
